import { cilWarning } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CTooltip } from '@coreui/react';
import { FC, useMemo, useState } from 'react';

import { openPrismicLink } from '@/utils/helpers.js';

import { usePrismicStore } from '@/zustandStore.js';

const PrismicCustomerCheck: FC = () => {
    const [showModal, setShowModal] = useState(false);
    const currentCustomer = usePrismicStore((state) => state.currentCustomer);

    const warnings: string[] = useMemo(() => {
        if (!currentCustomer) {
            return [];
        }

        const warningsArray: string[] = [];

        if (!currentCustomer.customer_name?.[0]?.text) {
            warningsArray.push('Customer Name fehlt');
        }

        if (!currentCustomer.customer_id?.[0]?.text) {
            warningsArray.push('Customer ID fehlt');
        }

        if (!currentCustomer.key?.[0]?.text) {
            warningsArray.push('Customer Key fehlt');
        }

        if (!currentCustomer.customer_icon_large?.url || !currentCustomer.customer_icon_small?.url) {
            warningsArray.push('Customer Icon fehlt');
        }

        if (
            !currentCustomer.primary_color ||
            !currentCustomer.secondary_color ||
            !currentCustomer.cta_font_color_dark ||
            !currentCustomer.cta_font_color_light
        ) {
            warningsArray.push('Customer Farben fehlen');
        }

        // TODO: add more checks

        return warningsArray;
    }, [currentCustomer]);

    if (warnings.length === 0) {
        return null;
    }

    return (
        <>
            <CTooltip content="Durch diese Fehler könnten Formulare von Patienten möglicherweise nicht korrekt verarbeiet werden">
                <CButton
                    onClick={() => setShowModal(true)}
                    color="light"
                    className="d-flex justify-content-center align-items-center gap-2"
                >
                    <CIcon icon={cilWarning} className="text-danger" />
                    {`Customer hat ${warnings.length} Fehler in Prismic`}
                </CButton>
            </CTooltip>

            <CModal visible={showModal} onClose={() => setShowModal(false)}>
                <CModalHeader>{`Customer hat ${warnings.length} Fehler in Prismic`}</CModalHeader>
                <CModalBody>
                    <ul className="m-0">
                        {warnings.map((warning) => (
                            <li key={warning}>{warning}</li>
                        ))}
                    </ul>
                </CModalBody>
                <CModalFooter>
                    <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
                        <CButton onClick={() => setShowModal(false)} variant="outline" color="dark">
                            Schließen
                        </CButton>
                        <CButton color="secondary" onClick={() => openPrismicLink(currentCustomer.id)}>
                            Customer bearbeiten
                        </CButton>
                    </div>
                </CModalFooter>
            </CModal>
        </>
    );
};

export default PrismicCustomerCheck;
